import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, OnInit, Output, signal } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { OnboardingAssessmentService } from '../onboarding-assessment-services/onboarding-assessment.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { Router } from '@angular/router';
import { declarationDetails, OnboardingAssesment, onboardingItems } from '../onboarding-assesment-interface/onboarding-assesment.interface';
import { HttpStatusCode } from 'axios';
import { OnboardingAssesmentModel } from '../onboarding-assesment-models/onboarding-assesment-model.model';
import { ConfirmPopupComponent } from '../../new-rep-application/confirm-popup/confirm-popup.component';
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AgentOnboardingService } from '../../agent-onboarding/agent-onboarding-service/agent-onboarding.service';
import { NewRepChecklistService } from '../../new-rep-checklist/new-rep-checklist-services/new-rep-checklist.service';
import { getChecklistItems } from '../../new-rep-checklist/new-rep-checklist-interfaces/save-new-rep-checklist.interface';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DocumentPreviewOverlayDirective } from '../../../../shared/directives/document-preview-overlay/document-preview-overlay.directive';

@Component({
  selector: 'app-due-diliegence',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatTooltipModule,
    DocumentPreviewOverlayDirective,
  ],
  templateUrl: './due-diliegence.component.html',
  styleUrl: './due-diliegence.component.scss'
})
export class DueDiliegenceComponent implements OnInit {

  private fb = inject(FormBuilder);
  private readonly matDialog = inject(MatDialog);
  private sanitizer = inject(DomSanitizer);
  readonly message = ' This field is required.';
  private sessionStorageService = inject(SessionStorageService);
  private onboardingAssessmentService = inject(OnboardingAssessmentService);
  private returnbyroleService = inject(AgentOnboardingService);
  private newRepChecklistService = inject(NewRepChecklistService);
  private snackBarService = inject(SnackbarService);
  private router = inject(Router);
  setSprinner = signal(false);

  submitted = signal(false);
  errormessage!: string;

  data = history.state;
  viewId!: number;
  viewOnboardingAssesment!: OnboardingAssesment[];
  declarationDetails!: declarationDetails;
  isReadOnly = signal(false);
  iseditable = signal(false);
  protected currentUserRole: string = "";

  selectedDocument!: SafeResourceUrl;
  isPdf = false;
  selectedFileIndex = 0;
  selectedItemFiles: any[] = [];
  protected getchecklistItems: getChecklistItems[] = [];
  checklistinvalidflag = signal(false);

  readonly MIN_ZOOM = 0.5;
  readonly MAX_ZOOM = 3;
  private readonly ZOOM_STEP = 0.25;
  zoomLevel = 1;

  dueDiligenceItems!: onboardingItems[];
  designation!: string;

  private readonly allowedFileTypes = ['application/pdf', 'image/jpeg', 'image/png'];
  private readonly allowedFileExtensions = ['pdf', 'jpg', 'jpeg', 'png'];
  private readonly maxFileSize = 5 * 1024 * 1024; // 5MB

  /* Files rejected out of a multi-file selection, keyed by due diligence item index. Rejections
     can't sit on a row control the way a single upload's error does, because a rejected file
     never gets a row — so they are reported here, above the item's attachments. */
  protected uploadErrors: Record<number, string[]> = {};

  /* The backend stores a different `onboardingDocumentType` per designation flow, so each item
     matches on both the Introducer and the standard agent naming. */
  private readonly documentTypesByItemId: Record<number, string[]> = {
    1: ['MAS Prohibition Order Check or Prohibition List Checking', 'prohibition_order_list'],
    2: ['Google Search', 'eservices_mas'],
    3: ['AML Screening', 'cea_gov'],
    4: ['Enforcement Actions', 'aml_screening'],
    5: ['sccb', 'Basic_Individual_Search'],
    6: ['processing_checkList', 'SPF_News'],
    7: ['medisave_payable', 'ACEAS_PublicRegister'],
    8: ['media_hub', 'ARCM & IPSR Portal_Powered by Merimen'],
    9: ['Financial Institution Representatives Register', 'public_search'],
  };

  public onboardingassessmentForm: FormGroup = this.fb.group({

    documents: this.fb.array([]),
    remarks: [''],
    declarationaccepted: ['', [Validators.required]],
    onboardingname: [''],
    date: ['']


  });


  //  Generic FormArray getter
  get documents(): FormArray {
    return this.onboardingassessmentForm.get('documents') as FormArray;
  }

  ngOnInit(): void {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.designation = this.data.designation;

    if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
      this.dueDiligenceItems = [
        {
          id: 1,
          label: 'MAS Prohibition Order Check',
          category_name: 'MAS Prohibition Order Check or Prohibition List Checking',
          url: '',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 2,
          label: this.designation === 'Introducer - Individual' ? 'Google Search' : 'AML / Sanctions Screening',
          category_name: 'Google Search',
          url: this.designation === 'Introducer - Individual' ? 'https://Google.com' : 'https://fccmcloud.ap-singapore-1.ocs.oraclecloud.com/tz836n-prd/dashboard-ui/main/home.jsp',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 3,
          label: this.designation === 'Introducer - Individual' ? 'AML / Sanctions Screening' : 'MAS Enforcement Actions Review',
          category_name: 'AML Screening',
          url: this.designation === 'Introducer - Individual' ? 'https://fccmcloud.ap-singapore-1.ocs.oraclecloud.com/tz836n-prd/dashboard-ui/main/home.jsp' : 'https://www.mas.gov.sg/regulation/enforcement/enforcement-action',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 4,
          label: this.designation === 'Introducer - Individual' ? 'MAS Enforcement Actions Review' : 'Singapore Credit Bureau Check (SCCB)',
          category_name: 'Enforcement Actions',
          url: this.designation === 'Introducer - Individual' ? 'https://www.mas.gov.sg/regulation/enforcement/enforcement-action' : 'https://www.sccb.sg/login_page',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 5,
          label: this.designation === 'Introducer - Individual' ? 'Singapore Credit Bureau Check (SCCB)' : 'Police Adverse News Screening',
          category_name: 'Basic_Individual_Search',
          url: this.designation === 'Introducer - Individual' ? 'https://www.sccb.sg/login_page' : 'https://www.police.gov.sg/Media-Hub/News?type=All&from=From&to=To',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 6,
          label: this.designation === 'Introducer - Individual' ? 'Police Adverse News Screening' : 'CEA Licence & Registration Check',
          category_name: 'SPF_News',
          url: this.designation === 'Introducer - Individual' ? 'https://www.police.gov.sg/Media-Hub/News?type=All&from=From&to=To' : 'https://eservices.cea.gov.sg/aceas/public-register/sales/1',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 7,
          label: this.designation === 'Introducer - Individual' ? 'CEA Licence & Registration Check' : 'ARCM Public Records Search',
          category_name: 'ACEAS_PublicRegister',
          url: this.designation === 'Introducer - Individual' ? 'https://eservices.cea.gov.sg/aceas/public-register/sales/1' : 'https://www.arcm.com.sg/public/client/arsPublic/PublicSearch',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 8,
          label: this.designation === 'Introducer - Individual' ? 'ARCM Public Records Search' : 'MAS Register of Representatives (RoR) Verification',
          category_name: 'ARCM & IPSR Portal_Powered by Merimen',
          url: this.designation === 'Introducer - Individual' ? 'https://www.arcm.com.sg/public/client/arsPublic/PublicSearch' : 'https://eservices.mas.gov.sg/rr',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 9,
          label: this.designation === 'Introducer - Individual' ? 'MAS Register of Representatives (RoR) Verification' : 'AML / Sanctions Screening',
          category_name: 'Financial Institution Representatives Register',
          url: this.designation === 'Introducer - Individual' ? 'https://eservices.mas.gov.sg/rr' : 'https://fccmcloud.ap-singapore-1.ocs.oraclecloud.com/tz836n-prd/dashboard-ui/main/home.jsp',
          file: [],
          upload: 'Multiple',
        }

      ];
    } else {
      this.dueDiligenceItems = [
        {
          id: 1,
          label: 'MAS Prohibition Order Check',
          category_name: 'prohibition_order_list',
          url: '',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 2,
          label: 'MAS Register of Representatives (RoR) Verification',
          category_name: 'eservices_mas',
          url: 'https://eservices.mas.gov.sg/rr',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 3,
          label: 'CEA Licence & Registration Check',
          category_name: 'cea_gov',
          url: 'https://eservices.cea.gov.sg/aceas/public-register/sales/1',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 4,
          label: 'AML / Sanctions Screening',
          category_name: 'aml_screening',
          url: '',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 5,
          label: 'Singapore Credit Bureau Check (SCCB)',
          category_name: 'sccb',
          url: 'https://www.sccb.sg/login_page',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 6,
          label: 'Reference Checks',
          category_name: 'processing_checkList',
          url: '',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 7,
          label: 'MAS Enforcement Actions Review',
          category_name: 'medisave_payable',
          url: 'https://www.mas.gov.sg/regulation/enforcement/enforcement-actions',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 8,
          label: 'Police Adverse News Screening',
          category_name: 'media_hub',
          url: 'https://www.police.gov.sg/Media-Hub/News?type=All&from=From&to=To',
          file: [],
          upload: 'Multiple',
        },
        {
          id: 9,
          label: 'ARCM Public Records Search',
          category_name: 'public_search',
          url: 'https://www.arcm.com.sg/public/client/arsPublic/PublicSearch',
          file: [],
          upload: 'Multiple',
        }

      ];
    }

    this.dueDiligenceItems.forEach((item: any) => {
      this.documents.push(
        this.fb.group({
          label: [item.label],
          category_name: [item.category_name],
          url: [item.url],
          file: [item.file],
          attachements: this.fb.array([
            this.createRow()
          ]),
        })
      );
    });

    this.viewId = this.data.id;
    this.viewPiasAssessment();
    this.getChecklistItems();
    this.isReadOnly.set(this.data.isReadOnly);
    if ((this.currentUserRole == 'DSU' && this.data.status == 'DSU Initial Assessment') || (this.currentUserRole == 'DSU' && this.data.status == 'DSU Final Assessment' && ['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation))) {
      this.iseditable.set(true);
    }
    if (this.isReadOnly() == true) {
      this.onboardingassessmentForm?.disable();
    } else {
      this.onboardingassessmentForm?.enable();
    }

    this.onboardingassessmentForm.get('declarationaccepted')?.valueChanges.subscribe(value => {
      if (value) {
        this.onboardingassessmentForm.patchValue({
          onboardingname: this.sessionStorageService.getCurrentUserPersonName(),
          date: this.getToday()
        }, { emitEvent: false });
        this.errormessage = '';
      } else {
        this.onboardingassessmentForm.patchValue({
          onboardingname: null,
          date: null
        }, { emitEvent: false });
        if (value == false) {
          this.onboardingassessmentForm.get('declarationaccepted')?.markAsTouched();
        }
      }
    });
  }

  //  Generic FormArray getter
  getAttachments(docIndex: number): FormArray {
    return this.documents.at(docIndex).get('attachements') as FormArray;
  }

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  //  Add row
  addAttachment(docIndex: number) {
    this.getAttachments(docIndex).push(this.createRow());
  }

  createRow(): FormGroup {
    return this.fb.group({
      document: [null],
      documentFilename: ['', [Validators.required]]
    });
  }


  showPreview = false;

  async previewDoc(item: any) {
    this.selectedItemFiles = item.file || [];
    // console.log(this.selectedItemFiles)
    this.selectedFileIndex = 0;
    this.loadFile(0);
    this.showPreview = true;

  }

  async loadFile(index: any) {
    if (this.selectedItemFiles && this.selectedItemFiles[index]) {
      const file = this.selectedItemFiles[index];

      if (file?.name) {
        try {

          const responseData = await this.onboardingAssessmentService
            .viewChecklistdocuments(file.fileid);

          // Create blob URL
          const fileURL = URL.createObjectURL(responseData);

          // Safe URL
          this.selectedDocument = this.sanitizer.bypassSecurityTrustResourceUrl(fileURL);

        } catch (error) {
          console.error(error);
        }
        this.isPdf = file?.name.toLowerCase().endsWith('.pdf');


      } else {
        console.error('URL is missing for file:', file);
      }

      this.selectedFileIndex = index;
      this.resetZoom();
    }
  }

  zoomIn(): void {
    this.zoomLevel = Math.min(this.MAX_ZOOM, +(this.zoomLevel + this.ZOOM_STEP).toFixed(2));
  }

  zoomOut(): void {
    this.zoomLevel = Math.max(this.MIN_ZOOM, +(this.zoomLevel - this.ZOOM_STEP).toFixed(2));
  }

  resetZoom(): void {
    this.zoomLevel = 1;
  }

  closePreview() {
    this.showPreview = false;
    this.resetZoom();
  }


  async onDocumentFileChange(event: Event, docIndex: number, attachmentIndex: number) {
    const input = event.target as HTMLInputElement;
    const files = Array.from(input.files ?? []);
    // Clear the native input so picking the same file again still fires a change event.
    input.value = '';

    const attachments = this.getAttachments(docIndex);
    const clickedControl = attachments.at(attachmentIndex);
    this.uploadErrors[docIndex] = [];

    if (files.length === 0) {
      clickedControl?.get('documentFilename')?.setValue(null);
      clickedControl?.get('documentFilename')?.markAsTouched();
      clickedControl?.get('documentFilename')?.updateValueAndValidity();
      return;
    }

    /* Screen the whole selection before anything reaches the form, so a rejected file is never
       listed as an attachment — the file picker's `accept` filter is only a hint and the user can
       always override it. */
    const acceptedFiles: File[] = [];
    const wrongTypeNames: string[] = [];
    const oversizedNames: string[] = [];

    for (const file of files) {
      if (!this.isAllowedFileType(file)) {
        wrongTypeNames.push(file.name);
      } else if (file.size > this.maxFileSize) {
        oversizedNames.push(file.name);
      } else {
        acceptedFiles.push(file);
      }
    }

    if (wrongTypeNames.length > 0) {
      this.uploadErrors[docIndex].push(
        `Only PDF, JPG, PNG files are allowed. Not uploaded: ${wrongTypeNames.join(', ')}`
      );
    }
    if (oversizedNames.length > 0) {
      this.uploadErrors[docIndex].push(
        `File size must be less than or equal to 5MB. Not uploaded: ${oversizedNames.join(', ')}`
      );
    }

    if (acceptedFiles.length === 0) {
      this.snackBarService.openFailureSnackBar(
        files.length === 1 ? "The selected file was not accepted." : "None of the selected files were accepted."
      );
      return;
    }

    this.setSprinner.set(true);
    let uploadedCount = 0;

    for (let i = 0; i < acceptedFiles.length; i++) {
      const file = acceptedFiles[i];

      // The first file takes over the row the user clicked; every extra file gets its own row.
      let rowIndex = attachmentIndex;
      if (i > 0) {
        attachments.push(this.createRow());
        rowIndex = attachments.length - 1;
      }

      const fileControl = attachments.at(rowIndex);
      fileControl.patchValue({
        document: file,
        documentFilename: file.name
      });
      const filenameControl = fileControl.get('documentFilename');
      filenameControl?.markAsTouched();
      filenameControl?.setErrors(null);

      const uploaded = await this.uploaddocument(docIndex, rowIndex);
      if (!uploaded) {
        // uploaddocument already reported the failure; drop the row back to empty and stop
        // instead of leaving a file listed that the API never took.
        this.discardRow(attachments, rowIndex, attachmentIndex);
        break;
      }
      uploadedCount++;
    }

    if (uploadedCount > 0) {
      await this.getdocuments();
      this.mapUploadedFilesToItems();
    }
    this.setSprinner.set(false);

    if (uploadedCount === 1) {
      this.snackBarService.openSuccessSnackBar("document uploaded successfully!");
    } else if (uploadedCount > 1) {
      this.snackBarService.openSuccessSnackBar(`${uploadedCount} documents uploaded successfully!`);
    }
  }

  /* The MIME type a browser reports is not dependable (it comes back empty for some sources and
     is trivially wrong for a renamed file), so the extension is the primary check and the MIME
     type only has to agree when the browser actually supplied one. */
  private isAllowedFileType(file: File): boolean {
    const extension = file.name.split('.').pop()?.toLowerCase() ?? '';

    if (!file.name.includes('.') || !this.allowedFileExtensions.includes(extension)) {
      return false;
    }
    return !file.type || this.allowedFileTypes.includes(file.type);
  }

  /* Puts a row back the way it was before a failed upload: the row the user clicked is emptied
     and kept, rows this selection added are dropped. */
  private discardRow(attachments: FormArray, rowIndex: number, clickedIndex: number): void {
    if (rowIndex === clickedIndex) {
      attachments.at(rowIndex).reset();
      attachments.at(rowIndex).get('documentFilename')?.markAsTouched();
      attachments.at(rowIndex).get('documentFilename')?.updateValueAndValidity();
    } else {
      attachments.removeAt(rowIndex);
    }
  }

  removeuploadfield(index: number, attachmentIndex: number) {
    this.uploadErrors[index] = [];
    this.getAttachments(index)?.removeAt(attachmentIndex);
  }

  removeFile(controlName: string, fileVar: string, index: number, attachmentIndex: number) {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to remove the attachement?',
        hidecancel: false,
      }
    });

    this.getdocuments();
    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        this.uploadErrors[index] = [];
        if (this.viewOnboardingAssesment) {
          let id;
          let docTypeId;
          this.viewOnboardingAssesment.forEach(item => {
            if (item?.onboardingDocumentType === this.documents.at(index).get('category_name')?.value && item.responseValue == String(attachmentIndex)) {
              id = item.id,
                docTypeId = item.docTypeId
            }
          });

          const data = {
            onboardingId: this.viewId,
            docTypeId: docTypeId,
            id: id
          }
          const responseData = await this.onboardingAssessmentService
            .deleteonbordingdocument(data)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
        }
        this.getAttachments(index).at(attachmentIndex)?.reset();
        if (this.getAttachments(index).length > 1) {
          this.getAttachments(index)?.removeAt(attachmentIndex);
        }
        this.getAttachments(index).at(attachmentIndex)?.get(fileVar)?.reset();
        this.getAttachments(index).at(attachmentIndex)?.get(controlName)?.markAsTouched();
        this.getAttachments(index).at(attachmentIndex)?.get(controlName)?.updateValueAndValidity();

        // Keep the preview list in step with what the API still holds.
        await this.getdocuments();
        this.mapUploadedFilesToItems();
        if (this.showPreview) {
          this.closePreview();
        }
        // }
      } else {
        // console.log('User cancelled');
      }
    });
  }

  /* Rebuilds each item's preview list from the documents the API currently holds. Rebuilt rather
     than appended so re-fetching (after an upload, a delete or a save) cannot duplicate entries. */
  private mapUploadedFilesToItems(): void {
    this.dueDiligenceItems.forEach((item: onboardingItems) => {
      const documentTypes = this.documentTypesByItemId[item.id] ?? [];

      item.file = (this.viewOnboardingAssesment ?? [])
        .filter((file: any) => documentTypes.includes(file.onboardingDocumentType))
        .map((file: any) => ({
          fileid: file.id,
          name: file.fileName,
          url: file.filePath
        }));
    });
  }

  async getdocuments() {
    const responseData = await this.onboardingAssessmentService
      .viewChecklistdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      this.viewOnboardingAssesment = responseData.data.responsedata;
    }
  }


  async viewPiasAssessment() {
    this.setSprinner.set(true);
    const responseData = await this.onboardingAssessmentService
      .viewChecklistdocumentslist(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    const declerationresponseData = await this.onboardingAssessmentService
      .viewOnboardingassessment(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {

      this.viewOnboardingAssesment = responseData.data.responsedata;
      this.declarationDetails = declerationresponseData.data.responsedata;

      this.mapUploadedFilesToItems();

      if ((['Onboarding', 'DSU'].includes(this.currentUserRole) && ['Onboarding Processing', 'DSU Initial Assessment'].includes(this.data.status) || this.iseditable())) {
        this.viewOnboardingAssesment.forEach(item => {
          const formIndex = this.documents.controls.findIndex(control =>
            control.get('category_name')?.value === item.onboardingDocumentType
          );

          if (formIndex !== -1) {
            const attachments = this.getAttachments(formIndex);

            // If no empty row is available, create one
            if (attachments.length === 0) {
              attachments.push(this.createRow());
            }

            // Find the first empty attachment row
            let attachmentIndex = attachments.controls.findIndex(control =>
              !control.get('documentFilename')?.value
            );

            // If all rows are filled, add a new one
            if (attachmentIndex === -1) {
              attachments.push(this.createRow());
              attachmentIndex = attachments.length - 1;
            }

            attachments.at(attachmentIndex).patchValue({
              documentFilename: item.fileName
            });
          }
        });
      }
      this.onboardingassessmentForm.controls['remarks'].setValue(this.declarationDetails?.remark?.remarkContent);
      this.onboardingassessmentForm.controls['declarationaccepted'].setValue(this.declarationDetails?.declaration_details?.piasIsAgree);
      if (this.onboardingassessmentForm.get('declarationaccepted')?.value == true) {
        this.onboardingassessmentForm.controls['onboardingname'].setValue(this.declarationDetails?.declaration_details?.onboardingName);
        this.onboardingassessmentForm.controls['date'].setValue(this.declarationDetails?.declaration_details?.piasDeclarationDate?.split('T')[0]);
      }
      // console.log(formArray.value);
      // console.log(this.viewOnboardingAssesment);

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  openConfirmDialog() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Are you sure you want to submit this Application?',
        hidecancel: false,
      }
    });
    this.getChecklistItems();
    dialogRef.afterClosed().subscribe(result => {
      if (result.data === true) {
        if (this.onboardingassessmentForm.get('declarationaccepted')?.value == true) {
          if (this.checklistinvalidflag() === true) {
            this.errormessage = 'Please complete the checklist';
            this.submitted.set(false);
          } else {
            this.submitted.set(true);
            this.saveAndContinue();
          }
        } else {
          this.errormessage = 'Please check the decleartion';
          this.submitted.set(false);
        }

      } else {
        // console.log('User cancelled');
      }
    });
  }

  async getChecklistItems() {
    const responseData = await this.newRepChecklistService
      .getChecklistItems(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {

      this.getchecklistItems = responseData.data.responsedata;
      if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.designation)) {
        this.checklistinvalidflag.set(
          this.getchecklistItems.length === 0 ||
          this.getchecklistItems
            .some(x => x.isCompleted == null || x.isCompleted == false)
        );
      } else {
        this.getchecklistItems = this.getchecklistItems.filter(
          x => x.categoryName.startsWith('minimumDocumentCheck_') || x.categoryName.startsWith('subsequentDocumentsCheck_')
        );
        const preferredOrder = [
          "minimumDocumentCheck_",
          "subsequentDocumentsCheck_",
        ];

        const getCategoryOrder = (categoryName = "") => {
          const index = preferredOrder.findIndex(prefix =>
            categoryName.startsWith(prefix)
          );
          return index === -1 ? preferredOrder.length : index;
        };

        const getSuffixNumber = (categoryName = "") => {
          const match = categoryName.match(/_(\d+)$/);
          return match ? Number(match[1]) : Number.MAX_SAFE_INTEGER;
        };

        this.getchecklistItems.sort((a, b) => {
          const orderA = getCategoryOrder(a.categoryName);
          const orderB = getCategoryOrder(b.categoryName);

          if (orderA !== orderB) {
            return orderA - orderB;
          }

          return getSuffixNumber(a.categoryName) - getSuffixNumber(b.categoryName);
        });

        this.checklistinvalidflag.set(
          this.getchecklistItems.filter(
            x => x.categoryName?.startsWith('minimumDocumentCheck_')
          ).length === 0 ||
          this.getchecklistItems
            .filter(x => x.categoryName?.startsWith('minimumDocumentCheck_'))
            .some(x => x.isCompleted == null || x.isCompleted == false)
        );
      }

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  /* Returns whether the upload succeeded so the caller can keep going through a multi-file
     selection (or stop and let the reported failure stand). */
  async uploaddocument(index: number, attachmentIndex: number): Promise<boolean> {
    let saveOnboardingassessment = new OnboardingAssesmentModel();
    saveOnboardingassessment.setOnboardingid(this.viewId);
    saveOnboardingassessment.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    saveOnboardingassessment.setAttachments([{
      onboardingid: this.viewId,
      docTypeId: 0,
      category_name: this.documents.at(index).get('category_name')?.value,
      fileName: this.getAttachments(index).at(attachmentIndex)?.get('document')?.value?.name,
      data: this.getAttachments(index).at(attachmentIndex)?.get('document')?.value instanceof Blob ? await this.convertToBase64(this.getAttachments(index).at(attachmentIndex)?.get('document')?.value) : '',
      contentType: this.getAttachments(index).at(attachmentIndex)?.get('document')?.value?.type,
      responseValue: String(attachmentIndex)
    }]);

    const responseData = await this.onboardingAssessmentService
      .saveOnboardingassessment(saveOnboardingassessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    if (responseData.status === HttpStatusCode.Ok) {
      return true;
    }

    if (responseData.code === HttpStatusCode.BadRequest) {
      // Display notification on API failure.
      this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
    }
    if (responseData.code === HttpStatusCode.Unauthorized) {
      this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
      this.router.navigate(['/login']);
    }
    return false;
  }

  async returnByRole() {
    const dialogRef = this.matDialog.open(ConfirmPopupComponent, {
      width: '500px',
      disableClose: true,
      data: {
        message: 'Do you want to return the application ?',
        hidecancel: false,
      }
    });

    dialogRef.afterClosed().subscribe(async result => {
      if (result.data === true) {
        this.setSprinner.set(true);
        let saveOnboardingassessment = new OnboardingAssesmentModel();
        saveOnboardingassessment.setOnboardingid(this.viewId);
        saveOnboardingassessment.setRemarkId(this.declarationDetails?.remark?.id);
        saveOnboardingassessment.setRemarkContent(this.onboardingassessmentForm.get('remarks')?.value);
        saveOnboardingassessment.setReturnComments(this.onboardingassessmentForm.get('remarks')?.value);
        saveOnboardingassessment.setupdatedbyroleRemark(this.sessionStorageService.getCurrentUserRole());
        saveOnboardingassessment.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
        saveOnboardingassessment.setpias_is_agree(false);

        const responseData = await this.onboardingAssessmentService
          .saveOnboardingassessment(saveOnboardingassessment)
          .then((response) => {
            return JSON.parse(response);
          })
          .catch((error) => {
            // console.error(error);
            return error;
          });
        if (responseData.status === HttpStatusCode.Ok) {
          let returndata = {
            id: this.viewId,
            status: 'Candidate Update (Due Diligence)',
            return_comments:saveOnboardingassessment.getReturnComments(),
          };

          const responseData = await this.returnbyroleService
            .statusreturn(returndata)
            .then((response) => {
              return JSON.parse(response);
            })
            .catch((error) => {
              // console.error(error);
              return error;
            });
          this.setSprinner.set(false);
          if (responseData.status === HttpStatusCode.Ok) {
            this.snackBarService.openSuccessSnackBar("Application returned successfully!");
            this.router.navigate(['/agent-onboarding']);

          } else {
            if (responseData.code === HttpStatusCode.BadRequest) {
              // Display notification on API failure.
              this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
            }
            if (responseData.code === HttpStatusCode.Unauthorized) {
              this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
              this.router.navigate(['/login']);
            }
          }
        } else {
          if (responseData.code === HttpStatusCode.BadRequest) {
            // Display notification on API failure.
            this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
          }
          if (responseData.code === HttpStatusCode.Unauthorized) {
            this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
            this.router.navigate(['/login']);
          }
        }
      } else {
        // console.log('User cancelled');
      }
    });

  }

  async getSavedAssessment(){
    this.setSprinner.set(true);
    const declerationresponseData = await this.onboardingAssessmentService
      .viewOnboardingassessment(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (declerationresponseData.status === HttpStatusCode.Ok) {
      this.declarationDetails = declerationresponseData.data.responsedata;
      this.onboardingassessmentForm.controls['remarks'].setValue(this.declarationDetails?.remark?.remarkContent);
      this.onboardingassessmentForm.controls['declarationaccepted'].setValue(this.declarationDetails?.declaration_details?.piasIsAgree);
      if (this.onboardingassessmentForm.get('declarationaccepted')?.value == true) {
        this.onboardingassessmentForm.controls['onboardingname'].setValue(this.declarationDetails?.declaration_details?.onboardingName);
        this.onboardingassessmentForm.controls['date'].setValue(this.declarationDetails?.declaration_details?.piasDeclarationDate?.split('T')[0]);
      }
      
    } else {
      if (declerationresponseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (declerationresponseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }


  async saveAndContinue() {
    this.setSprinner.set(true);
    let saveOnboardingassessment = new OnboardingAssesmentModel();
    saveOnboardingassessment.setOnboardingid(this.viewId);
    saveOnboardingassessment.setRemarkId(this.declarationDetails?.remark?.id);
    saveOnboardingassessment.setRemarkContent(this.onboardingassessmentForm.get('remarks')?.value);
    saveOnboardingassessment.setupdatedbyroleRemark(this.sessionStorageService.getCurrentUserRole());
    saveOnboardingassessment.setupdatedbyrole(this.sessionStorageService.getCurrentUserRole());
    if (this.submitted() == true) {
      saveOnboardingassessment.setpias_is_agree(this.onboardingassessmentForm.get('declarationaccepted')?.value);
      saveOnboardingassessment.setpias_declaration_date(this.onboardingassessmentForm.get('date')?.value + 'T00:00:00Z');
      saveOnboardingassessment.setonboarding_name(this.onboardingassessmentForm.get('onboardingname')?.value);
    } else {
      saveOnboardingassessment.setpias_is_agree(false);
    }


    const responseData = await this.onboardingAssessmentService
      .saveOnboardingassessment(saveOnboardingassessment)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });
    this.setSprinner.set(false);
    if (responseData.status === HttpStatusCode.Ok) {
      this.getSavedAssessment();
      if (this.submitted() == true) {
        this.snackBarService.openSuccessSnackBar("Application submitted successfully!");
        this.router.navigate(['/agent-onboarding']);
      } else {
        this.snackBarService.openSuccessSnackBar("Application saved successfully!");
      }
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }

  }

  convertToBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.readAsDataURL(file);

      reader.onload = () => {
        const result = reader.result as string;

        // Remove metadata prefix
        const base64 = result.split(',')[1];

        resolve(base64);
      };

      reader.onerror = error => reject(error);
    });
  }
}
